///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { GtthSharedModule } from '../shared/shared.module';
import { GtthServicesModule } from '../services/services.module';
import { RouterModule } from '@angular/router';
import { preferencesPopups } from './preferences.route';
import { GtthPreferencesEditDialogPopupComponent, PreferencesEditDialogComponent } from './preferences-edit-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SuiLoadingDirective, SuiNumberControlComponent, SuiSvgIconComponent, SuiTranslatePipe } from '@siklu/sui-lib';

const ENTITY_STATES = [...preferencesPopups];

@NgModule({
    imports: [
        GtthSharedModule,
        GtthServicesModule,
        MatDialogModule,
        RouterModule.forChild(ENTITY_STATES),
        SuiLoadingDirective,
        SuiTranslatePipe,
        SuiSvgIconComponent,
        SuiNumberControlComponent
    ],
    declarations: [PreferencesEditDialogComponent, GtthPreferencesEditDialogPopupComponent],
    providers: [],
    exports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GtthPreferencesModule {}
